var CacheEntry = /** @class */ /*@__PURE__*/ (function () {
    function CacheEntry(value) {
        this.value = value;
        this.timestamp = Date.now();
    }
    return CacheEntry;
}());
export { CacheEntry };
